import dateFormat from 'dateformat'
import toUpper from 'ramda/es/toUpper'
import Email from 'email-validator'

import i18n from 'services/i18n'

// Chat profiles the current membership cannot access come back from
// /profiles/v2 with empty user/membership details. Fall back to a placeholder
// name so those users are still labelled in chat.
export const roommateFirstName = roommate =>
  (roommate && roommate.first_name) || i18n.t('chat.userUnknown')

export const roommateFullName = roommate => {
  const fullName = `${(roommate && roommate.first_name) || ''} ${(roommate && roommate.last_name) || ''}`.trim()
  return fullName || i18n.t('chat.userUnknown')
}

// Members the current membership cannot access are omitted from the
// /profiles/v2 response, so the resolved roommate list can be shorter than the
// conversation's participants. Pad it with blank placeholders (rendered as
// "User Unknown") so every participant is still represented. `expectedCount` is
// the number of non-self participants expected in the conversation.
export const padUnknownRoommates = (resolved = [], expectedCount = 0) => {
  const missing = Math.max(0, expectedCount - resolved.length)
  return missing
    ? [...resolved, ...Array.from({ length: missing }, () => ({}))]
    : resolved
}

const alphaNumeric = /^[a-zA-Z0-9_-]*$/

export const formatDate = date => dateFormat(date, 'mmmm d, yyyy')
export const formatDateUTC = date => dateFormat(date, 'UTC:mmmm d, yyyy')

export const isAlphaNumeric = value => !alphaNumeric.test(value)

export const required = value => !(value || typeof value === 'number')

// Gender is stored as an object ({ name, id }); an empty selection is either
// falsy or an object without an id, so a plain `required` check is not enough.
export const genderRequired = value => !value || (typeof value === 'object' && !value.id)

// The backend rejects a save made without a gender as
// { error: { code: 'Not Found', description: 'gender.not_found was not found' } }.
// The payload lands at err.error.description when the API layer returns the body
// directly, or at err.body.error.description when it surfaces a thrown ResponseError
// (same "API wrapper variations" the other sagas defend against).
export const isGenderNotFoundError = err => {
  const description = err?.error?.description || err?.body?.error?.description || ''
  return typeof description === 'string' && description.includes('gender.not_found')
}

const maxLength = max => value => value && value.length > max

export const maxLength15 = maxLength(15)
export const maxLength30 = maxLength(30)
export const maxLength35 = maxLength(35)
export const maxLength50 = maxLength(50)
export const maxLength82 = maxLength(82)
export const maxLength250 = maxLength(250)
export const maxLength920 = maxLength(920)
export const maxLength1000 = maxLength(1000)
export const maxLength2200 = maxLength(2200)

const minLength = min => value => value && value.length < min

export const minLength5 = minLength(5)
export const minLength50 = minLength(50)

export const getProfanityWords = str => {
  return str.match(/<\s*span[^>]*>(.*?)<\s*\/s*span>/g).map(val => val.replace(/<\/?span[^>]*>/g, ''))
}

export const setToUpperCase = (text) => text.replace(/^./, toUpper)
export const isEmail = value => value && !Email.validate(value)
export const phoneValidation = value => value && (value.length > 17 || value.length < 9)

export const logEvent = async (action, traits) => {
  // Mixpanel removed - no-op function for compatibility
}

export const identify = async (userId, email) => {
  // Mixpanel removed - no-op function for compatibility
}
